<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M7 8.5H17M8.5 8.5L9 16.5H15L15.5 8.5M9.5 7.5H14.5" stroke="#000"/>
</svg>
